module.exports = __webpack_public_path__ + "static/logo-1a8fe925c5b71e37692038e1befb0d21.png";